<div class="container-fluid filter-value-wrapper">
    <form [formGroup]="form" novalidate>
        <div class="row" (click)="$event.stopPropagation()">
            <div class="col-md-12 header">
                {{'generic_enter_tracking_number' | translate}}
            </div>
        </div>
        <div class="row" (click)="$event.stopPropagation()">
            <div class="col-md-12 body">
                <supplystack-input-2 [valid]="customFormValidators.isFieldValid(value, submittedForm)">
                    <input type="text" formControlName="value">
                </supplystack-input-2>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12 actions" (click)="$event.stopPropagation()">
                <div></div>
            </div>
            <button mat-button class="theme-button" (click)="apply($event)">
                {{'generic_search' | translate}}
            </button>
        </div>
    </form>
</div>
